import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const codeAPI = apiConstants.codeAPI;
const group = work.basePath;

export const type = work.key;
export const panels = {
    municipal_works_home: {
        menu: {
            route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.${group}.home`,
            text: "Home - Mapa",
            icon: "fas fa-map-marked",
        },
        acl: {
            view: "GIM_22000",
        },
    },
    home_municipal_works: {
        menu: {
            route: `${code}.${group}.home`,
            text: "Gestão - Obras municipais",
            icon: "fas fa-building",
        },
        acl: {
            view: "GIM_22000",
        },
    },
    // municipal_works_work: {
    //     menu: {
    //         route: `${code}.municipal_works_work`,
    //         text: "Intervenções",
    //         icon: "fas fa-tasks",
    //     },
    //     acl: {
    //         view: "GIM_22011",
    //         detail: "GIM_22012",
    //         add: "GIM_22013",
    //         edit: "GIM_22024",
    //         delete: "GIM_22015",
    //     },
    //     url: {
    //         getList: `/${codeAPI}/municipal_works/work`,
    //         getShow: `/${codeAPI}/municipal_works/work/:id`,
    //         getCreate: `/${codeAPI}/municipal_works/work`,
    //         getUpdate: `/${codeAPI}/municipal_works/work/:id`,
    //         getDelete: `/${codeAPI}/municipal_works/work/:id`,
    //         getLists: `/${codeAPI}/municipal_works/work/lists`,
    //     },
    // },
    municipal_works_status: {
        menu: {
            route: `${code}.municipal_works_status`,
            text: "Estados",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_22011",
            detail: "GIM_22012",
            add: "GIM_22013",
            edit: "GIM_22024",
            delete: "GIM_22015",
        },
        url: {
            getList: `/${codeAPI}/municipal_works/status`,
            getShow: `/${codeAPI}/municipal_works/status/:id`,
            getCreate: `/${codeAPI}/municipal_works/status`,
            getUpdate: `/${codeAPI}/municipal_works/status/:id`,
            getDelete: `/${codeAPI}/municipal_works/status/:id`,
        },
    },
    municipal_works_applicant: {
        menu: {
            route: `${code}.municipal_works_applicant`,
            text: "Requerentes",
            icon: "fas fa-users",
        },
        acl: {
            view: "GIM_22011",
            detail: "GIM_22012",
            add: "GIM_22013",
            edit: "GIM_22024",
            delete: "GIM_22015",
        },
        url: {
            getList: `/${codeAPI}/municipal_works/applicant`,
            getShow: `/${codeAPI}/municipal_works/applicant/:id`,
            getCreate: `/${codeAPI}/municipal_works/applicant`,
            getUpdate: `/${codeAPI}/municipal_works/applicant/:id`,
            getDelete: `/${codeAPI}/municipal_works/applicant/:id`,
        },
    },
    municipal_works_type: {
        menu: {
            route: `${code}.municipal_works_type`,
            text: "Tipos",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_22011",
            detail: "GIM_22012",
            add: "GIM_22013",
            edit: "GIM_22024",
            delete: "GIM_22015",
        },
        url: {
            getList: `/${codeAPI}/municipal_works/type`,
            getShow: `/${codeAPI}/municipal_works/type/:id`,
            getCreate: `/${codeAPI}/municipal_works/type`,
            getUpdate: `/${codeAPI}/municipal_works/type/:id`,
            getDelete: `/${codeAPI}/municipal_works/type/:id`,
        },
    },
    municipal_works_global_type: {
        menu: {
            route: `${code}.municipal_works_type_global`,
            text: "Tipos - Globais",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_22011",
            detail: "GIM_22012",
            add: "GIM_22013",
            edit: "GIM_22024",
            delete: "GIM_22015",
        },
        url: {
            getList: `/${codeAPI}/gestao/municipal_works/type`,
            getShow: `/${codeAPI}/gestao/municipal_works/type/:id`,
            getCreate: `/${codeAPI}/gestao/municipal_works/type`,
            getUpdate: `/${codeAPI}/gestao/municipal_works/type/:id`,
            getDelete: `/${codeAPI}/gestao/municipal_works/type/:id`,
            getRelationship: `/${codeAPI}/:code/type`,
            getEntities: `/${codeAPI}/gestao/entities`,
        },
    },
    municipal_works_global_status: {
        menu: {
            route: `${code}.municipal_works_status_global`,
            text: "Estados - Globais",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_22011",
            detail: "GIM_22012",
            add: "GIM_22013",
            edit: "GIM_22024",
            delete: "GIM_22015",
        },
        url: {
            getList: `/${codeAPI}/gestao/municipal_works/status`,
            getShow: `/${codeAPI}/gestao/municipal_works/status/:id`,
            getCreate: `/${codeAPI}/gestao/municipal_works/status`,
            getUpdate: `/${codeAPI}/gestao/municipal_works/status/:id`,
            getDelete: `/${codeAPI}/gestao/municipal_works/status/:id`,
            getRelationship: `/${codeAPI}/:code/status`,
            getEntities: `/${codeAPI}/gestao/entities`,
        },
    },
};
